import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Edit from '@material-ui/icons/Edit';
import Input from '../../components/Input/Input';
import CapitalizeFirstLetters from './utils/CapitalizeFirstLetters';
import { setMessage } from '../../store/actions/general';

import authInstance from '../../config/authInstance';

const styles = theme => ({
  modalPadding: {
    padding: '0px 24px',
  },
  itemTitle: {
    color: 'rgba(0, 0, 0, 0.54)',
    paddingTop: 6,
    fontSize: 14,
    marginBottom: 4,
  },
  item: {
    border: '1px solid #999',
    borderRadius: '2px',
    height: '35px',
    paddingLeft: '5px',
    fontSize: 16,
    backgroundColor: '#F2F4FF',
  },
  containerItem: {
    display: 'flex',
  },
  buttonContainer: {
    paddingTop: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: 10,
  },
});

function ProfileModal(props) {
  const {
    onClose, selectedValue, classes, ...other
  } = props;
  const [openEmail, setOpenEmail] = React.useState(false);
  const [profile, setProfile] = React.useState({});
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(true);


  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);


  function handleChangeEmailOpen() {
    setOpenEmail(true);
  }

  function handleChangeEmailClose() {
    setOpenEmail(false);
  }

  async function changeEmail(token, email, password, onMessage, onLoading) {
    try {
      const response = await authInstance.post('/authentication/reset/email', { email, password }, {
        headers: { Authorization: ` Bearer ${token}` },
      });
      return (response.data && response.data.message) && onMessage(response.data.message);
    } catch (error) {
      dispatch(setMessage(error));
    }
    return setOpenEmail(false);
  }


  const weekDays = [
    'D', 'S', 'T', 'Q', 'Q', 'S', 'S',
  ];

  React.useEffect(() => {
    async function fetchProfile(token) {
      const user = await authInstance.get('/authentication/user/data/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProfile(user.data);
      setLoading(false);
    }
    if (auth.token) {
      fetchProfile(auth.token);
    }
    // eslint-disable-next-line
  }, []);

  const fillBullet = (days, index) => days.some(day => day === index);

  const renderBullets = (scale) => {
    const bullets = [];

    for (let i = 0; i < 7; i++) {
      bullets.push(<div
        key={i}
        style={{
                width: 25,
                height: 25,
                // backgroundColor: '#8898AA80',
                margin: 3,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: fillBullet(scale.days, i) ? 'rgba(224, 224, 224, 1)' : 'rgba(0, 0, 0, 0.87)',
                borderRadius: 50,
            }}
      >
        <text style={{ color: 'white' }}>
          {weekDays[i]}
        </text>
      </div>);
    }

    return bullets;
  };


  const renderScales = () => {
    const items = [];

    if (profile && profile.scales) {
      profile.scales.forEach((scale, index) => {
        items.push(<div key={index}>
          <div style={{display: 'flex', backgroundColor: 'transparent', flexDirection: 'row', marginTop: 10, marginBottom: 10}}>
            {
              scale.days[0] === -1 ?
                <div style={{ flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                  {/* <Text>TODO escala revezamento</Text> */}
                  <div style={{ marginBottom: 5, alignItems: 'center' }}>
                    <text>{scale.category === 'HOURS' ? 'horas' : 'dias'} de trabalho</text>
                    <text style={{ fontWeight: 'bold' }}>{scale.amountWork}</text>
                  </div>

                  <div style={{ backgroundColor: '#8898AA', height: 35, width: 1 }} />

                  <div style={{ marginBottom: 5, alignItems: 'center' }}>
                    <text>{scale.category === 'HOURS' ? 'horas' : 'dias'} de folga</text>
                    <text style={{ fontWeight: 'bold' }}>{scale.amountLoose}</text>
                  </div>
                </div> :
                  (scale.days[0] === -2 ?
                    <text>Nenhuma escala associada</text> :
                      renderBullets(scale)
                  )
            }
          </div>

          {
            scale.days[0] !== -2 ?
              <text>{scale.scale}</text> :
                null
          }
        </div>);
      });
    }
    return items;
  };

  function handleClose() {
    onClose(selectedValue);
  }

  function handleChangeEmail(event) {
    setEmail(event.target.value);
  }

  function handlePassword(event) {
    setPassword(event.target.value);
  }

  function handleConfirmEmail() {
    changeEmail(
      auth.token,
      email,
      password,
      props.onMessage,
      props.onLoading,
    );
  }

  const newEmail = openEmail && (<form autoComplete="off" onSubmit={handleConfirmEmail} style={{ display: 'flex', flexDirection: 'column' }}>
    <Input
      autoFocus
      elementType="input"
      type="email"
      name="email"
      label="Novo Email"
      onChange={handleChangeEmail}
      value={email}
      fullWidth
      required
    />
    <Input
      elementType="passwordToggle"
      type="password"
      onChange={handlePassword}
      name="password"
      label="Senha"
      fullWidth
      required
    />
    <div className={classes.buttonContainer}>
      <Button classesName={classes.button} onClick={handleChangeEmailClose}>Cancelar</Button>
      <Button className={classes.button} onClick={handleConfirmEmail} variant="contained" color="primary"> Enviar</Button>
    </div>

    </form>);

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" fullWidth {...other}>
      <DialogTitle>Perfil</DialogTitle>

      {loading ?
        <CircularProgress size={30} color="primary" style={{ margin: 'auto', marginBottom: '20px' }} /> :
        (
          <>
            <div className={classes.modalPadding}>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5em' }}>
                <text className={classes.itemTitle} >Nome</text>
                <text> {CapitalizeFirstLetters(profile.name)} </text>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5em' }}>
                <text className={classes.itemTitle} >Email</text>
                <div><text> {profile.email ? profile.email.toLowerCase() : ''} </text>
                  <IconButton onClick={handleChangeEmailOpen} >
                    <Edit />
                  </IconButton>
                </div>
                {newEmail}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <text className={classes.itemTitle} >Telefone</text>
                <text> {profile.phone} </text>
              </div>
            </div>

            <div style={{border: '1px solid rgba(0, 0, 0, 0.07)', marginTop: 15, marginBottom: 15 }} />

            <div className={classes.modalPadding}>
            <text>Empresa {profile.company}</text>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5em', marginTop: 10 }}>
                <text className={classes.itemTitle} >Cargo</text>
                <text> {CapitalizeFirstLetters(profile.office)} </text>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '0.5em' }}>
                <text className={classes.itemTitle} >Departamento</text>
                <text> {CapitalizeFirstLetters(profile.department)} </text>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: 20 }}>
                <text className={classes.itemTitle} >Escala</text>
                <text> {renderScales(profile.scales)} </text>
              </div>
            </div>
          </>
        )
      }
    </Dialog>
  );
}

ProfileModal.propTypes = {
  onClose: PropTypes.func,
  selectedValue: PropTypes.string,
};

export default withStyles(styles)(ProfileModal);
